import React from "react";

import { IgAutocomplete } from "./IgAutocomplete";
import { IgTextField } from "./IgTextField";

interface IgFilterAutocompleteProps {
  selectedValues?: string[] | null;
  allDataOptions: string[];
  filterKey: "customEvents" | "countryCodes";
  placeholder: string;
  getOptionLabel?: (option: any) => string;
  getOptionDisabled?: (option: any) => boolean;
  onChange: (
    values: string[],
    filterKey: "customEvents" | "countryCodes"
  ) => void;
  disableCloseOnSelect?: boolean;
}
export const IgFilterAutocomplete = ({
  placeholder,
  selectedValues,
  allDataOptions,
  getOptionLabel,
  onChange,
  filterKey,
  disableCloseOnSelect,
  getOptionDisabled,
}: IgFilterAutocompleteProps) => {
  return (
    <IgAutocomplete
      id={"auto-complete-analytics"}
      disableCloseOnSelect={disableCloseOnSelect ?? false}
      multiple={true}
      sx={{ minWidth: "240px" }}
      onChange={(event, value) => {
        onChange(value, filterKey);
      }}
      slotProps={{
        popper: {
          sx: { zIndex: "2000 !important" },
        },
      }}
      options={allDataOptions}
      getOptionLabel={getOptionLabel}
      getOptionDisabled={getOptionDisabled}
      value={selectedValues}
      filterSelectedOptions={true}
      renderInput={(params) => (
        <IgTextField
          {...params}
          sx={{
            "& .MuiInputBase-input": {
              fontSize: "14px",
            },
          }}
          size={"small"}
          variant={"outlined"}
          placeholder={placeholder}
        />
      )}
    />
  );
};
